import {
  Component,
  Inject,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ApiService } from "src/app/providers/api.service";
import { SM_CONSTANTS } from "../../constants/sm-constants";
import { Subscription } from "rxjs";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { RecordPaymentComponent } from "../record-payment/record-payment.component";
import { BookingListForInvoiceMergeComponent } from "../booking-list-for-invoice-merge/booking-list-for-invoice-merge.component";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { CustomConfirmDialogComponent } from "../custom-confirm-dialog/custom-confirm-dialog.component";

import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { TDocumentDefinitions } from "pdfmake/interfaces";
import { InvoiceShareByEmailComponent } from "src/app/pages/new-v2-pages/new-v2-component/invoice-share-by-email/invoice-share-by-email.component";
import { RecordPaymentForFitnessComponent } from "../record-payment-for-fitness/record-payment-for-fitness.component";
import { Router } from "@angular/router";
import { AuthService } from "src/app/providers/auth.service";
import { InvoiceShareByWhatsappComponent } from "src/app/pages/new-v2-pages/new-v2-component/invoice-share-by-whatsapp/invoice-share-by-whatsapp.component";
import { AlertForEmailComponent } from "../alert-for-email/alert-for-email.component";
import { SendPaymentLinkComponent } from "../send-payment-link/send-payment-link.component";
import { environment } from "src/environments/environment";
(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;


@Component({
  selector: 'sm-invoice-for-fitness',
  templateUrl: './invoice-for-fitness.component.html',
  styleUrls: ['./invoice-for-fitness.component.scss']
})
export class InvoiceForFitnessComponent implements OnInit, OnDestroy {
  isEntityForeign: string = localStorage.getItem(SM_CONSTANTS.IS_ENTITY_FOREIGN)!
  waa:any = localStorage.getItem(SM_CONSTANTS.WHATSAPP_ACCESS)
  invoiceDetails: any = [];
  private _apiSubscription: Subscription = new Subscription();
  @ViewChild("captureContainer", { static: false })
  captureContainer!: ElementRef;
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    private _apiService: ApiService,
    private _modelRef: MatDialog,
    private loaderservice: LoaderServiceService,
    private dialog: MatDialog,
    private router: Router,
    private authService:AuthService,
    private activemodal: MatDialogRef<InvoiceForFitnessComponent>
  ) {}
  invHash:any
  isOwner: boolean = false
  ngOnInit(): void {
    this.isOwner = this.authService.isOwner() 
    console.log(this.parentData);
    
    let data = this.parentData.data;
    this.invHash = this.parentData.data
    if(this.isEntityForeign == '0'){
      this._apiService.getMemberInvoiceDetails(data);

    }
    else if(this.isEntityForeign == '1'){
      this._apiService.getInternationalFitnessEntityInvoiceDetails(data,this.parentData.entityHash)
    }

    this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
      console.log("inInvoiceBookings3:", resData);
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_MEMBER_INVOICE_DETAILS
      ) {
        this.invoiceDetails = [];
        if (
          resData.result &&
          resData.result != null &&
          resData.result != "null"
        ) {
          this.invoiceDetails.push(resData.result[0]);
          this.invoiceDetails[0].invoiceDetails = JSON.parse(
            this.invoiceDetails[0].invoiceDetails
          );
          this.invoiceDetails[0].custom_items = JSON.parse(
            this.invoiceDetails[0].custom_items
          );
          this.invoiceDetails[0].products = JSON.parse(
            this.invoiceDetails[0].products
          );
          // this.invoiceDetails[0].appointmentArr = JSON.parse(
          //   this.invoiceDetails[0].appointmentArr
          // );
          this.invoiceDetails[0].date = new Date();
          // this.invoiceDetails[0].total_tax = this.invoiceDetails[0].cgst_cal_rate + this.invoiceDetails[0].igst_cal_rate + this.invoiceDetails[0].other_tax_cal_rate + this.invoiceDetails[0].service_tax_cal_rate + this.invoiceDetails[0].sgst_cal_rate + this.invoiceDetails[0].utgst_cal_rate;
          console.log(this.invoiceDetails);
        } else {
          // let bodyData = [
          //   {
          //     appointment_hash_id: data,
          //     is_primary: 1,
          //   },
          // ];
          // this._apiService.addEditEntityInvoice(bodyData);
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_INTERNATIONAL_FITNESS_ENTITY_INVOICE_DETAILS
      ) {
        this.invoiceDetails = [];
        if (
          resData.result &&
          resData.result != null &&
          resData.result != "null"
        ) {
          this.invoiceDetails.push(resData.result[0]);
          this.invoiceDetails[0].invoiceDetails = JSON.parse(
            this.invoiceDetails[0].invoiceDetails
          );
          this.invoiceDetails[0].custom_items = JSON.parse(
            this.invoiceDetails[0].custom_items
          );
          this.invoiceDetails[0].products = JSON.parse(
            this.invoiceDetails[0].products
          );
          // this.invoiceDetails[0].appointmentArr = JSON.parse(
          //   this.invoiceDetails[0].appointmentArr
          // );
          this.invoiceDetails[0].tax_value_details = JSON.parse(
            this.invoiceDetails[0].tax_value_details
          );
          this.invoiceDetails[0].tax_type_details = JSON.parse(
            this.invoiceDetails[0].tax_type_details
          );
          this.invoiceDetails[0].date = new Date();
          // this.invoiceDetails[0].total_tax = this.invoiceDetails[0].tax_value_details.reduce((sum:any, invoice:any) => sum + (invoice.tax_value || 0), 0)
          console.log(this.invoiceDetails);
        } else {
          // let bodyData = [
          //   {
          //     appointment_hash_id: data,
          //     is_primary: 1,
          //   },
          // ];
          // this._apiService.addEditEntityInvoice(bodyData);
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_ENTITY_INVOICE_DETAILS
      ) {
        if (resData.result) {
          this.invoiceDetails = [];
          this._apiService.getEntityInvoiceDetails(data);
        }
      }
      if (resData.responseType === SM_CONSTANTS.RESULT_API_RESET_INVOICE_DATA) {
        if (resData.result) {
          this.invoiceDetails = [];
          this.loaderservice.showLoader = false;
          this._apiService.getEntityInvoiceDetails(data);
        }
      }
    
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_ENTITY_INVOICE
      ) {
        if (resData.result) {
          this.parentData.ref.closeAll()
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_INTERNATIONAL_INVOICE_DETAILS
      ) {
        if (resData.result) {
          this.parentData.ref.closeAll()
        }
      }

      if(resData.responseType === SM_CONSTANTS.RESULT_API_RECORD_FITNESS_INVOICE){
        if (resData.result) {
          this.invoiceDetails = []
          if(this.isEntityForeign == '0'){
            this._apiService.getMemberInvoiceDetails(data);
      
          }
          else if(this.isEntityForeign == '1'){
            this._apiService.getInternationalFitnessEntityInvoiceDetails(data,this.parentData.entityHash)
          }
        } 
        
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_FITNESS_INTERNATIONAL_INVOICE_PAYMENT_RECORD){
        if (resData.result) {
          this.invoiceDetails = []
          if(this.isEntityForeign == '0'){
            this._apiService.getMemberInvoiceDetails(data);
      
          }
          else if(this.isEntityForeign == '1'){
            this._apiService.getInternationalFitnessEntityInvoiceDetails(data,this.parentData.entityHash)
          }
        } 
        
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_SERVICE_PAYMENT_LINK_FOR_ENTITY_INVOICE){
        if (resData.result) {
          if(resData.result.errorcode == 0){
            console.log(resData.result);
            this.loaderservice.showLoader = false
            let msg = resData.result?.data?.payment_link
            this._modelRef.open(SendPaymentLinkComponent, {
              width: '700px',
              data: {
                title: 'Payment Link',
                ref: this._modelRef,
                data: msg,
              },
            });

          }
          else if(resData.result.errorcode == 1){
            this.loaderservice.showLoader = false
            const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
              data : {
                title : 'Error!',
                message : resData.result.msg,
                okbtn : 'Ok',
                cancelbtn : 'Cancel',
                type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
              },
              disableClose : true
            });
            dialogRef.afterClosed().subscribe(result=>{
              console.log(result);
              if(result){ 
                this.activemodal.close()
                this.router.navigate(["/businesses", "details", "plan-and-renew"], {
                  queryParams: { entityHash: this.invoiceDetails[0].entity_hash_id },
                });
              }
            })
          }
          else if(resData.result.errorcode == 2){
            this.loaderservice.showLoader = false
            const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
              data : {
                title : 'Pack Expired!',
                message : 'Unable to create and send online payment link as Premium pack expired for this business.',
                okbtn : 'Buy pack',
                cancelbtn : 'Cancel',
                type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
              },
              disableClose : true
            });
            dialogRef.afterClosed().subscribe(result=>{
              console.log(result);
              if(result){ 
                this.activemodal.close()
                this.router.navigate(["/businesses", "details", "plan-and-renew"], {
                  queryParams: { entityHash: this.invoiceDetails[0].entity_hash_id },
                });
              }
            })
          }
        } 
        
      }

    });
  }

  openRecordPayment() {
    let data = {
      appointmentHash: this.parentData.data,
      payment_due: this.invoiceDetails[0].payment_due, 
      price: this.invoiceDetails[0].item_price,
      netPay: this.invoiceDetails[0].total_price,
      appArr: this.invoiceDetails[0].appointmentArr,
      invId: this.invoiceDetails[0].hash_id,
      entityHash: this.parentData.entityHash,
      memberHash: this.parentData.memberHash,
      customer_country_code: this.invoiceDetails[0].customer_country_code ??
        this.invoiceDetails[0].cust_country_code ?? this.invoiceDetails[0].country_code,
      customer_phone: this.invoiceDetails[0].cust_phone,
      customer_name: this.invoiceDetails[0].cust_name,
      cust_phone: this.invoiceDetails[0].cust_phone
    };
    this._modelRef.open(RecordPaymentForFitnessComponent, {
      width: "450px",
      data: {
        title: "Record Payment",
        ref: this._modelRef,
        data: data,
      },
    });
  }

  mergeInvoices() {
    this._modelRef.open(BookingListForInvoiceMergeComponent, {
      width: "1000px",
      data: {
        title: "Booking List",
        ref: this._modelRef,
        data: this.parentData.data,
      },
    });
  }

  resetInvoice() {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message: "Are you sure you want to reset this invoice?",
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        this.loaderservice.showLoader = true;
        // this._apiService.resetInvoiceData(this.parentData.data);
      }
    });
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }

  captureScreenshot() {
    const element = document.getElementById("capture"); // Replace 'elementId' with the actual ID of the element you want to capture
    html2canvas(element!).then((canvas: any) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();
      pdf.addImage(
        imgData,
        "PNG",
        0,
        0,
        canvas.width * 0.75,
        canvas.height * 0.75
      ); // You might need to adjust the dimensions
      pdf.save("screenshot.pdf");
    });
  }

  captureScreen() {
  

    // let pdf = new jsPDF("p", "pt", "a4");
    // pdf.html(this.captureContainer.nativeElement, {
    //   callback: (pdf) => {
    //     pdf.save(this.invoiceDetails[0].inv_no + ".pdf");
    //   },
    // });
    const servicesList = [];
    const tax = [];
    const totalArray = []
    const taxTypesArray = []


    //-------------- FOR SERVICES --------------------------
    if(this.invoiceDetails[0].invoiceDetails){
      for (const service of this.invoiceDetails[0].invoiceDetails) {
       console.log(service);
       
        servicesList.push({
            alignment: 'justify',
            columns: [
                {
                    text: service.serv_name + ' x ' + service.serv_quantity,
                    alignment: 'left'
                },
                {
                    text: (this.invoiceDetails[0].currency_symbol ? this.invoiceDetails[0].currency_symbol : '₹') + service.serv_cost.toFixed(2),
                    alignment: 'right',
                    bold: true
                }
            ],
            margin: [0, 0, 0, 2],
        });
    }

    }
    //-------------- FOR PRODUCTS --------------------------
    if(this.invoiceDetails[0].products){
      for (const service of this.invoiceDetails[0].products) {
       console.log(service);
       
        servicesList.push({
            alignment: 'justify',
            columns: [
                {
                    text: service.product_name + ' x ' + service.product_quantity,
                    alignment: 'left'
                },
                {
                    text: (this.invoiceDetails[0].currency_symbol ? this.invoiceDetails[0].currency_symbol : '₹') + service.product_cost.toFixed(2),
                    alignment: 'right',
                    bold: true
                }
            ],
            margin: [0, 0, 0, 2],
        });
    }

    }
  // -------------- FOR CUSTOM ITEMS --------------------------
  if(this.invoiceDetails[0].custom_items){
    for (const service of this.invoiceDetails[0].custom_items) {
     console.log(service);
     
      servicesList.push({
          alignment: 'justify',
          columns: [
              {
                  text: service.item_name + ' x ' + service.item_qty,
                  alignment: 'left'
              },
              {
                  text: (this.invoiceDetails[0].currency_symbol ? this.invoiceDetails[0].currency_symbol : '₹') + service.item_price.toFixed(2),
                  alignment: 'right',
                  bold: true
              }
          ],
          margin: [0, 0, 0, 2],
      });
  }

  }
//-------- TAX COLLECTION -------------------------
totalArray.push({
  alignment: 'justify',
  columns: [
    {
      text: 'Total',
      alignment: "left"
    },
    {
      text: (this.invoiceDetails[0].currency_symbol ? this.invoiceDetails[0].currency_symbol : '₹') + this.invoiceDetails[0].item_price.toFixed(2),
      alignment: "right",
      bold: "true"
    }
  ],
   margin: [0, 0, 0, 2],
})
  if(this.invoiceDetails[0].invoice_bill_type == 2 && this.invoiceDetails[0].total_tax && this.invoiceDetails[0].total_tax != '0.00' && this.invoiceDetails[0].total_tax != '0'){
    totalArray.push({
			alignment: 'justify',
			columns: [
				{
					text: 'Tax',
					alignment: "left"
				},
				{
					text: (this.invoiceDetails[0].currency_symbol ? this.invoiceDetails[0].currency_symbol : '₹') + (+this.invoiceDetails[0].total_tax).toFixed(2),
					alignment: "right",
					bold: "true"
				}
			],
			 margin: [0, 0, 0, 2],
		})
  }
  if(this.invoiceDetails[0].discount != 0){
    totalArray.push({
			alignment: 'justify',
			columns: [
				{
					text: 'Discount',
					alignment: "left"
				},
				{
					text: (this.invoiceDetails[0].currency_symbol ? this.invoiceDetails[0].currency_symbol : '₹') + this.invoiceDetails[0].discount.toFixed(2),
					alignment: "right",
					bold: "true"
				}
			],
			 margin: [0, 0, 0, 2],
		})
  }
  if(this.invoiceDetails[0].coupon_discount && this.invoiceDetails[0].coupon_discount != 0){
    totalArray.push({
			alignment: 'justify',
			columns: [
				{
					text: 'Coupon discount',
					alignment: "left"
				},
				{
					text: (this.invoiceDetails[0].currency_symbol ? this.invoiceDetails[0].currency_symbol : '₹') + this.invoiceDetails[0].coupon_discount.toFixed(2),
					alignment: "right",
					bold: "true"
				}
			],
			 margin: [0, 0, 0, 2],
		})
  }
  if(this.invoiceDetails[0].gst_no && this.invoiceDetails[0].gst_no != 'null'){
    taxTypesArray.push(   {
      text: [
          { text: "GST: ", style: "createdBy" },
          { text: this.invoiceDetails[0].gst_no && this.invoiceDetails[0].gst_no != 'null' ? this.invoiceDetails[0].gst_no : 'N/A', style: "subheader", bold: true, },
      ],
      alignment: "left",
       margin: [0, 0, 0, 5],
  })
  }
  if(this.invoiceDetails[0].pan_no && this.invoiceDetails[0].pan_no != 'null'){
    taxTypesArray.push(
   {
      text: [
          { text: "PAN: ", style: "createdBy" },
          { text: this.invoiceDetails[0].pan_no && this.invoiceDetails[0].pan_no != 'null' ? this.invoiceDetails[0].pan_no : 'N/A', style: "subheader", bold: true, },
      ],
      alignment: "left",
       margin: [0, 0, 0, 5],
  })
  }
  if(this.invoiceDetails[0].tan_no && this.invoiceDetails[0].tan_no != 'null'){
    taxTypesArray.push({
      text: [
          { text: "TAN: ", style: "createdBy" },
          { text: this.invoiceDetails[0].tan_no && this.invoiceDetails[0].tan_no != 'null' ? this.invoiceDetails[0].tan_no : 'N/A', style: "subheader", bold: true, },
      ],
      alignment: "left",
       margin: [0, 0, 0, 5],
  })
  }
  // tax.push({
  //   alignment: 'justify',
  //   columns: [
  //     {
  //       text: 'Total',
  //       alignment: "left"
  //     },
  //     {
  //       text: (this.invoiceDetails[0].currency_symbol ? this.invoiceDetails[0].currency_symbol : '₹') + this.invoiceDetails[0].untaxed_amount.toFixed(2),
  //       alignment: "right",
  //       bold: "true"
  //     }
  //   ],
  //    margin: [0, 0, 0, 2],
  // },)
  if(this.invoiceDetails[0].cgst_value && this.invoiceDetails[0].cgst_value != 0){
    tax.push({
			alignment: 'justify',
			columns: [
				{
					text: 'Total CGST',
					alignment: "left"
				},
				{
					text: (this.invoiceDetails[0].currency_symbol ? this.invoiceDetails[0].currency_symbol : '₹') + this.invoiceDetails[0].cgst_value.toFixed(2),
					alignment: "right",
					bold: "true"
				}
			],
			 margin: [0, 0, 0, 2],
		})
  }
  if(this.invoiceDetails[0].sgst_value && this.invoiceDetails[0].sgst_value != 0){
    tax.push({
			alignment: 'justify',
			columns: [
				{
					text: 'Total SGST',
					alignment: "left"
				},
				{
					text: (this.invoiceDetails[0].currency_symbol ? this.invoiceDetails[0].currency_symbol : '₹') + this.invoiceDetails[0].sgst_value.toFixed(2),
					alignment: "right",
					bold: "true"
				}
			],
			 margin: [0, 0, 0, 2],
		})
  }
  if(this.invoiceDetails[0].igst_value && this.invoiceDetails[0].igst_value != 0){
    tax.push({
			alignment: 'justify',
			columns: [
				{
					text: 'Total IGST',
					alignment: "left"
				},
				{
					text: (this.invoiceDetails[0].currency_symbol ? this.invoiceDetails[0].currency_symbol : '₹') + this.invoiceDetails[0].igst_value.toFixed(2),
					alignment: "right",
					bold: "true"
				}
			],
			 margin: [0, 0, 0, 2],
		})
  }


  if(this.invoiceDetails[0].utgst_value && this.invoiceDetails[0].utgst_value != 0){
    tax.push({
			alignment: 'justify',
			columns: [
				{
					text: 'Total UTGST',
					alignment: "left"
				},
				{
					text: (this.invoiceDetails[0].currency_symbol ? this.invoiceDetails[0].currency_symbol : '₹') + this.invoiceDetails[0].utgst_value.toFixed(2),
					alignment: "right",
					bold: "true"
				}
			],
			 margin: [0, 0, 0, 2],
		})
  }
  if(this.invoiceDetails[0].service_tax && this.invoiceDetails[0].service_tax != 0){
    tax.push({
			alignment: 'justify',
			columns: [
				{
					text: 'Total Service Tax',
					alignment: "left"
				},
				{
					text: (this.invoiceDetails[0].currency_symbol ? this.invoiceDetails[0].currency_symbol : '₹') + this.invoiceDetails[0].service_tax.toFixed(2),
					alignment: "right",
					bold: "true"
				}
			],
			 margin: [0, 0, 0, 2],
		})
  }
  if(this.invoiceDetails[0].other_tax && this.invoiceDetails[0].other_tax != 0){
    tax.push({
			alignment: 'justify',
			columns: [
				{
					text: 'Total Other Tax',
					alignment: "left"
				},
				{
					text: (this.invoiceDetails[0].currency_symbol ? this.invoiceDetails[0].currency_symbol : '₹') + this.invoiceDetails[0].other_tax.toFixed(2),
					alignment: "right",
					bold: "true"
				}
			],
			 margin: [0, 0, 0, 2],
		})
  }


const invoiceDate = new Date(this.invoiceDetails[0].creation_date);
const formattedInvoiceDate = invoiceDate.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
});
  const invoiceFromDate = this.invoiceDetails[0].billing_from_date  ? new Date(this.invoiceDetails[0].billing_from_date) : new Date();
const formattedInvoiceFromDate = invoiceFromDate.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
});
  const invoiceToDate = this.invoiceDetails[0].billing_to_date ? new Date(this.invoiceDetails[0].billing_to_date) : new Date();
const formattedInvoiceToDate = invoiceToDate.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
});

    const dd: any = {
      content: [
        {
            text: (this.invoiceDetails[0].invoice_type == 3 || this.invoiceDetails[0].invoice_type == 4) ? 'Membership Tax Invoice' : 'Tax Invoice',
            style: "header",
            alignment: "left",
            margin: [0, 0, 0, 5],
            color: "#727272"
        },
        {
            text: this.invoiceDetails[0].inv_no,
            style: "subheader",
            alignment: "left",
            bold: true,
            margin: [0, 0, 0, 2],
        },
        {
            text: this.invoiceDetails[0].entity_name,
            style: "subheader",
            alignment: "left",
            bold: true,
            margin: [0, 0, 0, 2],
        },
        {
            text: this.invoiceDetails[0].entity_address,
            style: "subheader",
            alignment: "left",
            bold: true,
            margin: [0, 0, 0, 5],
        },
        {
            text: [
                { text: "Created by: ", style: "createdBy" },
                { text: this.invoiceDetails[0].creator_name ? this.invoiceDetails[0].creator_name : 'N/A' , style: "subheader", bold: true, },
            ],
            alignment: "left",
            margin: [0, 0, 0, 2],
        },
         ...taxTypesArray,
        {
            canvas: [
                {
                    type: "line",
                    x1: 0,
                    y1: 5,
                    x2: 516,
                    y2: 5,
                    lineWidth: 0.5,
                    lineColor: "#d3d3d3",
                },
            ],
             margin: [0, 0, 0, 10],
        },
         {
            text: [
                { text: "Bill to: ", style: "createdBy" },
                { text: this.invoiceDetails[0].cust_name, style: "subheader", bold: true, },
            ],
            alignment: "left",
            margin: [0, 0, 0, 2],
        },
         {
            text: [
                { text: "Phone: ", style: "createdBy" },
                { text: (this.invoiceDetails[0].country_code	 && this.invoiceDetails[0].country_code	 != 'null' ? this.invoiceDetails[0].country_code	 : '') + ' ' + this.invoiceDetails[0].cust_phone, style: "subheader", bold: true, },
            ],
            alignment: "left",
            margin: [0, 0, 0, 2],
            
        },
         
        {
            canvas: [
                {
                    type: "line",
                    x1: 0,
                    y1: 5,
                    x2: 516,
                    y2: 5,
                    lineWidth: 0.5,
                    lineColor: "#d3d3d3",
                },
            ],
             margin: [0, 0, 0, 10],
             id: '1r'
            
        },
        ...servicesList,
		 {
            canvas: [
                {
                    type: "line",
                    x1: 0,
                    y1: 5,
                    x2: 516,
                    y2: 5,
                    lineWidth: 0.5,
                    lineColor: "#d3d3d3",
                },
            ],
             margin: [0, 0, 0, 10],
            
        },
        
    ...totalArray,
		{
            canvas: [
                {
                    type: "line",
                    x1: 0,
                    y1: 5,
                    x2: 516,
                    y2: 5,
                    lineWidth: 0.5,
                    lineColor: "#d3d3d3",
                },
            ],
             margin: [0, 0, 0, 10],
            
        },
  
        {
			alignment: 'justify',
			columns: [
				{
					text: 'Net Payable',
					alignment: "left"
				},
				{
					text: (this.invoiceDetails[0].currency_symbol ? this.invoiceDetails[0].currency_symbol : '₹') + this.invoiceDetails[0].total_price.toFixed(2),
					alignment: "right",
					bold: "true"
				}
			],
			 margin: [0, 0, 0, 5],
		},
		{
            canvas: [
                {
                    type: "line",
                    x1: 0,
                    y1: 5,
                    x2: 516,
                    y2: 5,
                    lineWidth: 0.5,
                    lineColor: "#d3d3d3",
                },
            ],
             margin: [0, 0, 0, 10],
            
        },
        {
			alignment: 'justify',
			columns: [
				{
					text: 'Payment Amount',
					alignment: "left"
				},
				{
					text: (this.invoiceDetails[0].currency_symbol ? this.invoiceDetails[0].currency_symbol : '₹') + (this.invoiceDetails[0].customer_payment ? this.invoiceDetails[0].customer_payment.toFixed(2) : '0.00'),
					alignment: "right",
					bold: "true"
				}
			],
			 margin: [0, 0, 0, 5],
		},
        {
			alignment: 'justify',
			columns: [
				{
					text: 'Payment Due',
					alignment: "left"
				},
				{
					text: (this.invoiceDetails[0].currency_symbol ? this.invoiceDetails[0].currency_symbol : '₹') + (this.invoiceDetails[0].payment_due ? this.invoiceDetails[0].payment_due.toFixed(2) : '0.00'),
					alignment: "right",
					bold: "true"
				}
			],
			 margin: [0, 0, 0, 5],
		},
    {
      canvas: [
          {
              type: "line",
              x1: 0,
              y1: 5,
              x2: 516,
              y2: 5,
              lineWidth: 0.5,
              lineColor: "#d3d3d3",
          },
      ],
       margin: [0, 0, 0, 10],
      
  },
        {
			alignment: 'justify',
			columns: [
				{
					text: 'Payment Mode',
					alignment: "left"
				},
				{
					text: this.invoiceDetails[0].payment_mode ? this.invoiceDetails[0].payment_mode : 'N/A',
					alignment: "right",
					bold: "true"
				}
			],
			 margin: [0, 0, 0, 5],
		},
		{
			alignment: 'justify',
			columns: [
				{
					text: 'Reference Id',
					alignment: "left"
				},
				{
					text: this.invoiceDetails[0].pay_ref_id ? this.invoiceDetails[0].pay_ref_id : 'N/A',
					alignment: "right",
					bold: "true"
				}
			],
			 margin: [0, 0, 0, 5],
		},

    // TAX ARRAY START
			// {
      //       canvas: [
      //           {
      //               type: "line",
      //               x1: 0,
      //               y1: 5,
      //               x2: 516,
      //               y2: 5,
      //               lineWidth: 0.5,
      //               lineColor: "#d3d3d3",
      //           },
      //       ],
      //        margin: [0, 0, 0, 10],
            
      //   },
      //   ...tax,
      //   {
      //     canvas: [
      //       {
      //           type: "line",
      //           x1: 0,
      //           y1: 5,
      //           x2: 516,
      //           y2: 5,
      //           lineWidth: 0.5,
      //           lineColor: "#d3d3d3",
      //       },
      //   ],
      //    margin: [0, 0, 0, 10],
      //   },
      //   {
      //   alignment: 'justify',
      //   columns: [
      //     {
      //       text: 'Total tax collected',
      //       alignment: "left"
      //     },
      //     {
      //       text: (this.invoiceDetails[0].currency_symbol ? this.invoiceDetails[0].currency_symbol : '₹') + (+this.invoiceDetails[0].total_tax).toFixed(2),
      //       alignment: "right",
      //       bold: "true"
      //     }
      //   ],
      //   margin: [0, 0, 0, 5],
      // },
// TAX ARRAY END

      {
        canvas: [
          {
              type: "line",
              x1: 0,
              y1: 5,
              x2: 516,
              y2: 5,
              lineWidth: 0.5,
              lineColor: "#d3d3d3",
          },
      ],
       margin: [0, 0, 0, 10],
      },
      {
        text: [
            { text: "Invoice powered by LookzUp.", style: "smallFont" },
        ],
        alignment: "left",
         margin: [0, 0, 0, 5],
    },
    {
        text: [
            { text: "Visit lookzup.com for more info.", style: "smallFont" },
           
        ],
        alignment: "left",
         margin: [0, 0, 0, 5],
    }
],
styles: {
    createdBy: {
        color: "#727272", // Change the color as needed
    },
    smallFont: {
      color: "#727272",
      fontSize: 8
    }
}
    };


  
    
    let dynamicFields : any = []
    if(this.invoiceDetails[0].cgst_value > 0 || this.invoiceDetails[0].sgst_value > 0 || this.invoiceDetails[0].igst_value > 0 || this.invoiceDetails[0].utgst_value > 0 || this.invoiceDetails[0].service_tax > 0 || this.invoiceDetails[0].other_tax > 0){
      dynamicFields = [
      //   {
      //     canvas: [
      //         {
      //             type: "line",
      //             x1: 0,
      //             y1: 5,
      //             x2: 516,
      //             y2: 5,
      //             lineWidth: 0.5,
      //             lineColor: "#d3d3d3",
      //         },
      //     ],
      //      margin: [0, 0, 0, 10],
          
      // },
      ...tax,
      {
        canvas: [
          {
              type: "line",
              x1: 0,
              y1: 5,
              x2: 516,
              y2: 5,
              lineWidth: 0.5,
              lineColor: "#d3d3d3",
          },
      ],
       margin: [0, 0, 0, 10],
      },
      {
      alignment: 'justify',
      columns: [
        {
          text: 'Total tax collected',
          alignment: "left"
        },
        {
          text: (this.invoiceDetails[0].currency_symbol ? this.invoiceDetails[0].currency_symbol : '₹') + (+this.invoiceDetails[0].total_tax).toFixed(2),
          alignment: "right",
          bold: "true"
        }
      ],
      margin: [0, 0, 0, 5],
    },
    {
      canvas: [
        {
            type: "line",
            x1: 0,
            y1: 5,
            x2: 516,
            y2: 5,
            lineWidth: 0.5,
            lineColor: "#d3d3d3",
        },
    ],
     margin: [0, 0, 0, 10],
    }
     ]
    }else {
      dynamicFields = []
    }
    dd.content.splice(dd.content.length - 2, 0, ...(Array.isArray(dynamicFields) ? dynamicFields : [dynamicFields]));



// for date
 
let dynamicFields2 = []
if((!this.invoiceDetails[0].billing_from_date || this.invoiceDetails[0].billing_from_date == 'null' ) && (!this.invoiceDetails[0].billing_to_date || this.invoiceDetails[0].billing_to_date == 'null')){
  dynamicFields2 = [
     {
        text: [
            { text: "Date: ", style: "createdBy" },
            { text: formattedInvoiceDate,
           style: "subheader", bold: true, },
        ],
        alignment: "left",
         margin: [0, 0, 0, 5],
    }
 ]
}else {
  dynamicFields2 = [
    {
      text: [
          { text: "Membership period: ", style: "createdBy" },
          { text: formattedInvoiceFromDate + ' - ' + formattedInvoiceToDate,
         style: "subheader", bold: true, },
      ],
      alignment: "left",
       margin: [0, 0, 0, 5],
  },
  ]
}

let indexofdivision = dd.content.findIndex((item:any) => item.id == '1r') 
dd.content.splice(indexofdivision, 0, ...(Array.isArray(dynamicFields2) ? dynamicFields2 : [dynamicFields2]));

console.log(dd.content);

    
  pdfMake.createPdf(dd).download(this.invoiceDetails[0].inv_no);
  }
  captureScreen2() {
  
    const servicesList = [];
    const tax = [];
    const totalArray = []
    const noOfBookings = []
    const taxValues = []

    //-------------- FOR SERVICES --------------------------
    if(this.invoiceDetails[0].invoiceDetails){
      for (const service of this.invoiceDetails[0].invoiceDetails) {
       console.log(service);
       
        servicesList.push({
            alignment: 'justify',
            columns: [
                {
                    text: service.serv_name + ' x ' + service.serv_quantity,
                    alignment: 'left'
                },
                {
                    text: (this.invoiceDetails[0].currency_symbol ? this.invoiceDetails[0].currency_symbol : '₹') + service.serv_cost.toFixed(2),
                    alignment: 'right',
                    bold: true
                }
            ],
            margin: [0, 0, 0, 2],
        });
    }

    }
    //-------------- FOR PRODUCTS --------------------------
    if(this.invoiceDetails[0].products){
      for (const service of this.invoiceDetails[0].products) {
       console.log(service);
       
        servicesList.push({
            alignment: 'justify',
            columns: [
                {
                    text: service.product_name + ' x ' + service.product_qty,
                    alignment: 'left'
                },
                {
                    text: (this.invoiceDetails[0].currency_symbol ? this.invoiceDetails[0].currency_symbol : '₹') + service.product_price.toFixed(2),
                    alignment: 'right',
                    bold: true
                }
            ],
            margin: [0, 0, 0, 2],
        });
    }

    }
    // -------------- FOR CUSTOM ITEMS --------------------------
    if(this.invoiceDetails[0].custom_items){
  
      for (const service of this.invoiceDetails[0].custom_items) {
        console.log(service);
        
          servicesList.push({
              alignment: 'justify',
              columns: [
                  {
                      text: service.item_name + ' x ' + service.item_qty,
                      alignment: 'left'
                  },
                  {
                      text: (this.invoiceDetails[0].currency_symbol ? this.invoiceDetails[0].currency_symbol : '₹') + service.item_price.toFixed(2),
                      alignment: 'right',
                      bold: true
                  }
              ],
              margin: [0, 0, 0, 2],
          });
      }
    }
      //----------------- tax values ---------------
      if(this.invoiceDetails[0].tax_type_details){
        for(const taxvalue of this.invoiceDetails[0].tax_type_details){
          taxValues.push({
            text: [
                { text: taxvalue.taxation_type +  ": ", style: "createdBy" },
                { text: taxvalue.identification_no, style: "subheader", bold: true, },
            ],
            alignment: "left",
             margin: [0, 0, 0, 5],
        },)
  
        }
      }

//-------- TAX COLLECTION -------------------------
totalArray.push({
  alignment: 'justify',
  columns: [
    {
      text: 'Total',
      alignment: "left"
    },
    {
      text: (this.invoiceDetails[0].currency_symbol ? this.invoiceDetails[0].currency_symbol : '₹') + this.invoiceDetails[0].item_price.toFixed(2),
      alignment: "right",
      bold: "true"
    }
  ],
   margin: [0, 0, 0, 2],
})
  if(this.invoiceDetails[0].invoice_bill_type == 2 && this.invoiceDetails[0].total_tax && this.invoiceDetails[0].total_tax != '0.00' && this.invoiceDetails[0].total_tax != 0){
    totalArray.push({
      alignment: 'justify',
      columns: [
        {
          text: 'Tax',
          alignment: "left"
        },
        {
          text: (this.invoiceDetails[0].currency_symbol ? this.invoiceDetails[0].currency_symbol : '₹') + (+this.invoiceDetails[0].total_tax).toFixed(2),
          alignment: "right",
          bold: "true"
        }
      ],
       margin: [0, 0, 0, 2],
    })
  }
  if(this.invoiceDetails[0].discount != 0){
    totalArray.push({
      alignment: 'justify',
      columns: [
        {
          text: 'Discount',
          alignment: "left"
        },
        {
          text: (this.invoiceDetails[0].currency_symbol ? this.invoiceDetails[0].currency_symbol : '₹') + this.invoiceDetails[0].discount.toFixed(2),
          alignment: "right",
          bold: "true"
        }
      ],
       margin: [0, 0, 0, 2],
    })
  }
  if(this.invoiceDetails[0].coupon_discount && this.invoiceDetails[0].coupon_discount != 0){
    totalArray.push({
      alignment: 'justify',
      columns: [
        {
          text: 'Coupon discount',
          alignment: "left"
        },
        {
          text: (this.invoiceDetails[0].currency_symbol ? this.invoiceDetails[0].currency_symbol : '₹') + this.invoiceDetails[0].coupon_discount.toFixed(2),
          alignment: "right",
          bold: "true"
        }
      ],
       margin: [0, 0, 0, 2],
    })
  }

  if(this.invoiceDetails[0].tax_value_details){
    for (const taxvale of this.invoiceDetails[0].tax_value_details) {
      tax.push({
        alignment: 'justify',
        columns: [
          {
            text: 'Total ' +  taxvale.tax_name,
            alignment: "left"
          },
          {
            text: (this.invoiceDetails[0].currency_symbol ? this.invoiceDetails[0].currency_symbol : '₹') + taxvale.tax_value.toFixed(2),
            alignment: "right",
            bold: "true"
          }
        ],
         margin: [0, 0, 0, 2],
      })
    }

  }
  

  const invoiceDate = new Date(this.invoiceDetails[0].creation_date);
const formattedInvoiceDate = invoiceDate.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
});
  const invoiceFromDate = this.invoiceDetails[0].billing_from_date  ? new Date(this.invoiceDetails[0].billing_from_date) : new Date();
const formattedInvoiceFromDate = invoiceFromDate.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
});
  const invoiceToDate = this.invoiceDetails[0].billing_to_date ? new Date(this.invoiceDetails[0].billing_to_date) : new Date();
const formattedInvoiceToDate = invoiceToDate.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
});

    const dd: any = {
      content: [
        {
            text: (this.invoiceDetails[0].invoice_type == 3 || this.invoiceDetails[0].invoice_type == 4) ? 'Membership Tax Invoice' : 'Tax Invoice',
            style: "header",
            alignment: "left",
            margin: [0, 0, 0, 5],
            color: "#727272"
        },
        {
            text: this.invoiceDetails[0].inv_no,
            style: "subheader",
            alignment: "left",
            bold: true,
            margin: [0, 0, 0, 2],
        },
        {
            text: this.invoiceDetails[0].entity_name,
            style: "subheader",
            alignment: "left",
            bold: true,
            margin: [0, 0, 0, 2],
        },
        {
            text: this.invoiceDetails[0].entity_address,
            style: "subheader",
            alignment: "left",
            bold: true,
            margin: [0, 0, 0, 5],
        },
        {
            text: [
                { text: "Created by: ", style: "createdBy" },
                { text: this.invoiceDetails[0].creator_name, style: "subheader", bold: true, },
            ],
            alignment: "left",
            margin: [0, 0, 0, 2],
        },
        ...taxValues,
        {
            canvas: [
                {
                    type: "line",
                    x1: 0,
                    y1: 5,
                    x2: 516,
                    y2: 5,
                    lineWidth: 0.5,
                    lineColor: "#d3d3d3",
                },
            ],
             margin: [0, 0, 0, 10],
        },
         {
            text: [
                { text: "Bill to: ", style: "createdBy" },
                { text: this.invoiceDetails[0].cust_name, style: "subheader", bold: true, },
            ],
            alignment: "left",
            margin: [0, 0, 0, 2],
        },
         {
            text: [
                { text: "Phone: ", style: "createdBy" },
                { text: (this.invoiceDetails[0].cust_country_code	 && this.invoiceDetails[0].cust_country_code	 != 'null' ? this.invoiceDetails[0].cust_country_code	 : '')	 + ' ' + this.invoiceDetails[0].cust_phone, style: "subheader", bold: true, },
            ],
            alignment: "left",
            margin: [0, 0, 0, 2],
        },
        //  {
        //     text: [
        //         { text: "Date: ", style: "createdBy" },
        //         { text: formattedInvoiceDate,
        //        style: "subheader", bold: true, },
        //     ],
        //     alignment: "left",
        //      margin: [0, 0, 0, 5],
        // },
        
        {
            canvas: [
                {
                    type: "line",
                    x1: 0,
                    y1: 5,
                    x2: 516,
                    y2: 5,
                    lineWidth: 0.5,
                    lineColor: "#d3d3d3",
                },
            ],
             margin: [0, 0, 0, 10],
             id: '1r'
            
        },
        ...servicesList,
		 {
            canvas: [
                {
                    type: "line",
                    x1: 0,
                    y1: 5,
                    x2: 516,
                    y2: 5,
                    lineWidth: 0.5,
                    lineColor: "#d3d3d3",
                },
            ],
             margin: [0, 0, 0, 10],
            
        },
        
    ...totalArray,
		{
            canvas: [
                {
                    type: "line",
                    x1: 0,
                    y1: 5,
                    x2: 516,
                    y2: 5,
                    lineWidth: 0.5,
                    lineColor: "#d3d3d3",
                },
            ],
             margin: [0, 0, 0, 10],
            
        },
      
        {
			alignment: 'justify',
			columns: [
				{
					text: 'Net Payable',
					alignment: "left"
				},
				{
					text: (this.invoiceDetails[0].currency_symbol ? this.invoiceDetails[0].currency_symbol : '₹') + this.invoiceDetails[0].total_price.toFixed(2),
					alignment: "right",
					bold: "true"
				}
			],
			 margin: [0, 0, 0, 5],
		},
		{
            canvas: [
                {
                    type: "line",
                    x1: 0,
                    y1: 5,
                    x2: 516,
                    y2: 5,
                    lineWidth: 0.5,
                    lineColor: "#d3d3d3",
                },
            ],
             margin: [0, 0, 0, 10],
            
        },
        {
			alignment: 'justify',
			columns: [
				{
					text: 'Payment Amount',
					alignment: "left"
				},
				{
					text: (this.invoiceDetails[0].currency_symbol ? this.invoiceDetails[0].currency_symbol : '₹') + (this.invoiceDetails[0].customer_payment ? this.invoiceDetails[0].customer_payment.toFixed(2) : '0.00'),
					alignment: "right",
					bold: "true"
				}
			],
			 margin: [0, 0, 0, 5],
		},
        {
			alignment: 'justify',
			columns: [
				{
					text: 'Payment Due',
					alignment: "left"
				},
				{
					text: (this.invoiceDetails[0].currency_symbol ? this.invoiceDetails[0].currency_symbol : '₹') + (this.invoiceDetails[0].payment_due ? this.invoiceDetails[0].payment_due.toFixed(2) : '0.00'),
					alignment: "right",
					bold: "true"
				}
			],
			 margin: [0, 0, 0, 5],
		},
    {
      canvas: [
          {
              type: "line",
              x1: 0,
              y1: 5,
              x2: 516,
              y2: 5,
              lineWidth: 0.5,
              lineColor: "#d3d3d3",
          },
      ],
       margin: [0, 0, 0, 10],
      
  },
        {
			alignment: 'justify',
			columns: [
				{
					text: 'Payment Mode',
					alignment: "left"
				},
				{
					text: this.invoiceDetails[0].payment_mode ? this.invoiceDetails[0].payment_mode : 'N/A',
					alignment: "right",
					bold: "true"
				}
			],
			 margin: [0, 0, 0, 5],
		},
		{
			alignment: 'justify',
			columns: [
				{
					text: 'Reference Id',
					alignment: "left"
				},
				{
					text: this.invoiceDetails[0].pay_ref_id ? this.invoiceDetails[0].pay_ref_id : 'N/A',
					alignment: "right",
					bold: "true"
				}
			],
			 margin: [0, 0, 0, 5],
		},
			{
            canvas: [
                {
                    type: "line",
                    x1: 0,
                    y1: 5,
                    x2: 516,
                    y2: 5,
                    lineWidth: 0.5,
                    lineColor: "#d3d3d3",
                },
            ],
             margin: [0, 0, 0, 10],
            
        },
        {
          text: [
              { text: "Invoice powered by LookzUp.", style: "smallFont" },
          ],
          alignment: "left",
           margin: [0, 0, 0, 5],
      },
      {
          text: [
              { text: "Visit lookzup.com for more info.", style: "smallFont" },
             
          ],
          alignment: "left",
           margin: [0, 0, 0, 5],
      }
  ],
  styles: {
      createdBy: {
          color: "#727272", // Change the color as needed
      },
      smallFont: {
        color: "#727272",
        fontSize: 10
      }
  }
    };

    let dynamicFields : any = []
    if(this.invoiceDetails[0].tax_value_details){
      dynamicFields = [
 
      ...tax,
      {
        canvas: [
          {
              type: "line",
              x1: 0,
              y1: 5,
              x2: 516,
              y2: 5,
              lineWidth: 0.5,
              lineColor: "#d3d3d3",
          },
      ],
       margin: [0, 0, 0, 10],
      },
      {
      alignment: 'justify',
      columns: [
        {
          text: 'Total tax collected',
          alignment: "left"
        },
        {
          text: (this.invoiceDetails[0].currency_symbol ? this.invoiceDetails[0].currency_symbol : '₹') + (+this.invoiceDetails[0].total_tax).toFixed(2),
          alignment: "right",
          bold: "true"
        }
      ],
      margin: [0, 0, 0, 5],
    },
    {
      canvas: [
        {
            type: "line",
            x1: 0,
            y1: 5,
            x2: 516,
            y2: 5,
            lineWidth: 0.5,
            lineColor: "#d3d3d3",
        },
    ],
     margin: [0, 0, 0, 10],
    }
     ]
    }else {
      dynamicFields = []
    }
    dd.content.splice(dd.content.length - 2, 0, ...(Array.isArray(dynamicFields) ? dynamicFields : [dynamicFields]));

    



    let dynamicFields2 = []
    if((!this.invoiceDetails[0].billing_from_date || this.invoiceDetails[0].billing_from_date == 'null' ) && (!this.invoiceDetails[0].billing_to_date || this.invoiceDetails[0].billing_to_date == 'null')){
      dynamicFields2 = [
         {
            text: [
                { text: "Date: ", style: "createdBy" },
                { text: formattedInvoiceDate,
               style: "subheader", bold: true, },
            ],
            alignment: "left",
             margin: [0, 0, 0, 5],
        }
     ]
    }else {
      dynamicFields2 = [
         {
            text: [
                { text: "Membership period: ", style: "createdBy" },
                { text: formattedInvoiceFromDate + ' - ' + formattedInvoiceToDate,
               style: "subheader", bold: true, },
            ],
            alignment: "left",
             margin: [0, 0, 0, 5],
        },
        //  {
        //     text: [
        //         { text: "To Date: ", style: "createdBy" },
        //         { text: formattedInvoiceToDate,
        //        style: "subheader", bold: true, },
        //     ],
        //     alignment: "left",
        //      margin: [0, 0, 0, 5],
        // },
      ]
    }

    let indexofdivision = dd.content.findIndex((item:any) => item.id == '1r') 
    dd.content.splice(indexofdivision, 0, ...(Array.isArray(dynamicFields2) ? dynamicFields2 : [dynamicFields2]));

    
    pdfMake.createPdf(dd).download(this.invoiceDetails[0].inv_no);
    // pdfMake.createPdf(dd).open();
  }


  shareInWhatsapp(){
    

    let dialogref = this.dialog.open(InvoiceShareByWhatsappComponent, {
      width: '500px',
      data:{
        entityHash: this.invoiceDetails[0].entity_hash_id,
        invoiceHash: this.invoiceDetails[0].hash_id,
        phone: this.invoiceDetails[0].cust_phone,
        countryCode: this.invoiceDetails[0].country_code ? this.invoiceDetails[0].country_code : this.invoiceDetails[0].cust_country_code ,
      }
    })
    dialogref.afterClosed().subscribe(res => {
      if(res){
        if(res.errorcode == 0){
          const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
            data : {
              title : 'Success!',
              message : 'Successfully shared invoice with customer over WhatsApp.',
              okbtn : 'Ok',
              cancelbtn : 'Cancel',
              type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
            },
            disableClose : true
          });

        }
        else if(res.errorcode == 1){
          const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
            data : {
              title : 'Pack expired!',
              message : 'Unable to send the invoice via WhatsApp as Premium pack expired for this business. ',
              okbtn : 'Buy pack',
              cancelbtn : 'Cancel',
              type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
            },
            disableClose : true
          });
          dialogRef.afterClosed().subscribe(result=>{
            console.log(result);
            if(result){ 
              this.activemodal.close()
              this.router.navigate(["/businesses", "details", "plan-and-renew"], {
                queryParams: { entityHash: this.invoiceDetails[0].entity_hash_id },
              });
            }
          })
        }
         else if(res.errorcode == 2){
            const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
              data : {
                title : 'Alert',
                message : 'Unable to send the invoice via WhatsApp. Check the phone number and retry.',
                okbtn : 'Ok',
                cancelbtn : 'Cancel',
                type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
              },
              disableClose : true
            });
          }
          else if(res.errorcode == 3){
            const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
              data : {
                title : 'Alert',
                message : 'Unable to send the invoice via WhatsApp. Your business exceeded current quota. Contact support or raise a ticket.',
                okbtn : 'Ok',
                cancelbtn : 'Cancel',
                type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
              },
              disableClose : true
            });
          }
        else{
          const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
            data : {
              title : 'Alert',
              message : 'We are facing some issue with WhatsApp message sending. Try again.',
              okbtn : 'Ok',
              cancelbtn : 'Cancel',
              type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
            },
            disableClose : true
          });
        }
      }
    })


}


  printInvoice(){
    const printContents = this.captureContainer.nativeElement.innerHTML;
    const originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
  }

  
  shareInEmail(){
     let dialogref = this.dialog.open(InvoiceShareByEmailComponent, {
       width: '500px',
       data:{
         entityHash: this.invoiceDetails[0].entity_hash_id,
         invoiceHash: this.invoiceDetails[0].hash_id
       }
     })
     dialogref.afterClosed().subscribe(res => {
       if(res){
         if(res.errorcode == 0){
           if(res.unsuccessfull_emails && res.unsuccessfull_emails.length > 0){
             const dialogRef1 = this.dialog.open(AlertForEmailComponent,{
              width:'450px',
               data : {
                 title : 'Error !',
                 message1 : 'The following recipient unsubscribed to email sending from LookzUp platform. Contact support to send him/her email.',
                 message2 : res.unsuccessfull_emails.join(', '),
                 okbtn : 'Ok',
                 cancelbtn : 'Cancel',
                 type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
               },
               disableClose : true
             });
 
           }
           else{
             const dialogRef1 = this.dialog.open(CustomConfirmDialogComponent,{
               data : {
                 title : 'Success!',
                 message : 'Successfully shared invoice with customer over Email.',
                 okbtn : 'Ok',
                 cancelbtn : 'Cancel',
                 type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
               },
               disableClose : true
             });
 
           }
         }
         else if(res.errorcode == 1){
           const dialogRef1 = this.dialog.open(CustomConfirmDialogComponent,{
             data : {
               title : 'Pack expired!',
               message : 'Unable to send the invoice via Email as Premium pack expired for this business.',
               okbtn : 'Buy pack',
               cancelbtn : 'Cancel',
               type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
             },
             disableClose : true
           });
           dialogRef1.afterClosed().subscribe(result=>{
             console.log(result);
             if(result){ 
               this.activemodal.close()
               this.router.navigate(["/businesses", "details", "plan-and-renew"], {
                 queryParams: { entityHash: this.invoiceDetails[0].entity_hash_id },
               });
             }
           })
         }
          else if(res.errorcode == 2){
          const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
            data : {
              title : 'Alert',
              message : 'Unable to send the invoice via Email. Your business exceeded current quota. Contact support or raise a ticket.',
              okbtn : 'Ok',
              cancelbtn : 'Cancel',
              type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
            },
            disableClose : true
          });
        }
           else{
           const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
             data : {
               title : 'Alert',
               message : 'Email sending failed. Please try again after some time.',
               okbtn : 'Ok',
               cancelbtn : 'Cancel',
               type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
             },
             disableClose : true
           });
         }
       }
     })
   }
  deleteInvoice(){
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent,{
      width: '500px',
      data : {
        title : 'Alert',
        message : 'Deleting an invoice will remove the service data as well the payment information associated with this. Are you sure want to proceed?',
        okbtn : 'Yes',
        cancelbtn : 'Cancel',
        type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
      },
      disableClose : true
    });
    dialogRef.afterClosed().subscribe(result=>{
      console.log(result);
      if(result){ 
        let obj = {
          invoiceHash : this.invoiceDetails[0].hash_id
        }

        this.loaderservice.showLoader = true
        if(this.isEntityForeign == '0'){
          this._apiService.deleteEntityInvoice(obj)

        }
        else if(this.isEntityForeign == '1'){
          this._apiService.deleteInternationalInvoiceDetails(obj)
        }
      }
    })

  }

  sendPaymentLink(){
   let msg = environment.base_lookzup_market_website_url + '/invoice?hash=' + this.invoiceDetails[0].hash_id + '&type=1'
    this._modelRef.open(SendPaymentLinkComponent, {
      width: '700px',
      data: {
        title: 'Payment Link',
        ref: this._modelRef,
        data: msg,
      },
    });

  }

   sendInternationalPaymentLink(){
    let msg = environment.base_lookzup_market_website_url + '/invoice?hash=' + this.invoiceDetails[0].hash_id + '&type=2'
    this._modelRef.open(SendPaymentLinkComponent, {
      width: '700px',
      data: {
        title: 'Payment Link',
        ref: this._modelRef,
        data: msg,
      },
    });
  }
}
  